/*!
 * Get the contrasting color for any hex color
 * (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com
 * Derived from work by Brian Suda, https://24ways.org/2010/calculating-color-contrast/
 * @param  {String} A hexcolor value
 * @return {String} The contrasting color (black or white)
 */

export interface ColorType {
    name: string;
    hex: string;
    yiq: number;
    code?: string;
}

export function getYIQ(hexcolor: string): number {
    // If a leading # is provided, remove it
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }

    // If a three-character hexcode, make six-character
    if (hexcolor.length === 3) {
        hexcolor = hexcolor
            .split('')
            .map(function (hex) {
                return hex + hex;
            })
            .join('');
    }

    // Convert to RGB value
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);

    // Get YIQ ratio
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;

    // Check contrast
    // return yiq >= 128 ? '#264567' : 'white';
    return yiq;
}

export function getContrast(hexcolor: string): string {
    const yiq = getYIQ(hexcolor);
    // Check contrast
    // return yiq >= 128 ? '#264567' : 'white';
    return yiq >= 192 ? '#264567' : 'white';
}

export function compareYIQ(a: ColorType, b: ColorType): number {
    if (a.yiq < b.yiq) {
        return 1;
    }
    if (a.yiq > b.yiq) {
        return -1;
    }
    return 0;
}

export function getColor(propertyValue: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(propertyValue).trim();
}
